import { render, staticRenderFns } from "./ITPersonnel.vue?vue&type=template&id=23797393&"
import script from "./ITPersonnel.vue?vue&type=script&lang=js&"
export * from "./ITPersonnel.vue?vue&type=script&lang=js&"
import style0 from "./ITPersonnel.vue?vue&type=style&index=0&id=23797393&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports